import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsApi } from '../Analytics.api';

export const usePageViewTracking = (): void => {
    const location = useLocation();

    useEffect(() => {
        analyticsApi.trackPageView();
    }, [location]);
};
